<div class="example-container mat-elevation-z2">
  <mat-table #table [dataSource]="organisations">
    <ng-container cdkColumnDef="selection">
      <mat-header-cell *cdkHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="_selection.hasValue() && isAllSelected()"
          [indeterminate]="_selection.hasValue() && !isAllSelected()"
          [aria-label]="'Select All'"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? _selection.toggle(row) : null"
          [checked]="_selection.isSelected(row)"
          [aria-label]="'Select'"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef>Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <a
          *ngIf="row.link; else name"
          [routerLink]="row.link.routerLink"
          [queryParams]="row.link.queryParams"
          >{{ row.name }}</a
        >
        <ng-template #name>{{ row.name }}</ng-template>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="number">
      <mat-header-cell *cdkHeaderCellDef>Phone Number</mat-header-cell>
      <mat-cell *cdkCellDef="let row"> {{ row.contactNumber }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="address">
      <mat-header-cell *cdkHeaderCellDef>Address</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <span *ngIf="row.address"> {{ row.address?.address1 }},&nbsp;</span>
        <span *ngIf="row.address?.address2">{{ row.address.address2 }}</span>
        <span *ngIf="row.address?.town"
          >{{ row.address.town }} {{ row.address.state }}
          {{ row.address.postcode }}</span
        >
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="tenant">
      <mat-header-cell *cdkHeaderCellDef>Tenant</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <span *ngIf="row.tenantId != null && tenants[row.tenantId] != null">
          {{ tenants[row.tenantId]?.name }}</span
        >
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="_displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: _displayedColumns"></mat-row>
  </mat-table>
</div>
